import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import {
  DynamicDialogRef,
  DialogService,
  DynamicDialogConfig,
} from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { CalendarModule } from 'primeng/calendar';
import { DatePickerModule } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import { dateRangeValidator } from '@core/validators/date-range.validator';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-cadastra-programa-formacao',
  imports: [
    CommonModule,
    ButtonModule,
    InputTextModule,
    ReactiveFormsModule,
    HttpClientModule,
    SelectModule,
    CalendarModule,
    NgxMaskDirective,
    NgxMaskPipe,
    // NgxMaskModule.forRoot(),
    TextareaModule,
    DatePickerModule,
    ToastModule
  ],
  providers: [DialogService, provideNgxMask(), MessageService],
  templateUrl: './cadastra-programa-formacao.component.html',
  styleUrls: ['./cadastra-programa-formacao.component.scss'],
  standalone: true,
})
export class CadastraProgramaFormacaoComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private fb = inject(FormBuilder);
  messageService = inject(MessageService);


  tiposPrograma = [
    { label: 'INTERNA', value: 1 },
    { label: 'EXTERNA', value: 2 },
  ];
  coberturas = [
    { label: 'Total', value: 1 },
    { label: 'Parcial', value: 2 },
  ];

  programaForm = this.fb.group(
    {
      id: [0],
      nome: ['', Validators.required],
      descricao: ['', Validators.required],
      valorMensal: ['', [Validators.required, Validators.min(0)]],
      duracaoMeses: ['', [Validators.required, Validators.min(1)]],
      tipo: ['', Validators.required],
      cobertura: ['', Validators.required],
      dataInicio: ['', Validators.required],
      dataFim: ['', Validators.required],
    },
    { validators: dateRangeValidator('dataInicio', 'dataFim', 'dataInicioFimRange') }
  );
  prefix = '';
  isEditMode = false;

  ngOnInit() {
    if (this.config.data) {
      this.programaForm.patchValue({
        ...this.config.data,
        tipo: this.config.data.tipoProgramaValueEnum
      });
      this.isEditMode = true;
    }
  }

  save() {
    if (this.programaForm.valid) {
      const dataInicio = this.isEditMode
        ? this.formatDateToISO(this.programaForm.value.dataInicio as any)
        : (this.programaForm.value.dataInicio as any);
      const dataFim = this.isEditMode
        ? this.formatDateToISO(this.programaForm.value.dataFim as any)
        : (this.programaForm.value.dataInicio as any);

      this.ref.close({
        ...this.programaForm.value,
        dataInicio: dataInicio,
        dataFim: dataFim,
      }); // Close the dialog and pass data back
    } else {
      this.programaForm.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Por favor, preencha todos os campos obrigatórios.',
      });
    }
  }

formatDateToISO(dateInput: any): string {
  if (!dateInput) return '';

  if (dateInput instanceof Date) {
    return dateInput.toISOString();
  }

  if (typeof dateInput === 'string' && dateInput.includes('/')) {
    const [day, month, year] = dateInput.split('/').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.toISOString();
  }

  const date = new Date(dateInput);
  if (!isNaN(date.getTime())) {
    return date.toISOString();
  }

  console.warn('Formato de data não reconhecido:', dateInput);
  return '';
}


  updatePrefix(event: any) {
    // Lógica para actualizar o prefixo com base no valor de entrada
    // Exemplo: this.prefix = event.target.value ? 'R$ ' : '';
  }

  cancel() {
    this.ref.close(); // Close the dialog without saving
  }
}
